export default __webpack_public_path__ + "static/wispaylogo-10bb75e3ca03e7dc2219b4ffb1c43438.svg";